<template>
  <div class="skeleton-loader loading-animation">
    <div v-if="hidecontent" class="box-content">
      <p class="message-skeleton" v-html="message"></p>
      <div class="box-button">
        <button @click="linkButton()" class="btn  btn-block btn-friday" v-text="namebutton"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      isLoading: true
    };
  },
  props: {
    height: {
      type: String
    },
    width: {
      type: String,
      default: '100%'
    },
    borderradius: {
      type: String
    },
    maxwidth: {
      type: String
    },
    margin: {
      type: String
    },
    message: {
      type: String
    },
    position: {
      type: String
    },
    namebutton: {
      type: String
    },
    linkurl: {
      type: String
    },
    hidecontent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    linkButton () {
      window.location = this.linkurl
    }
  }
};
</script>

<style scoped>
.skeleton-loader {
  width: v-bind(width);
  max-width: v-bind(maxwidth);
  height: v-bind(height);
  border-radius: v-bind(borderradius);
  margin: v-bind(margin);
  position: v-bind(position);
  overflow: hidden;
  background-color: #ececec;
  user-select: none;
}
.box-content {
  position: absolute;
  top: 0;
  align-content: center;
  display: grid;
  height: inherit;
}
.btn-friday{
  background-image: linear-gradient(272deg, #f90 -46.65%, #f9da51 163.65%);
  border: none;
}
.box-button {
  padding: 16px;
}
.message-skeleton {
  color: #000;
  padding: 0 16px;
  text-align: center;
}
.loading-animation::before {
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  animation: loading 1s infinite;
  background: linear-gradient(to right, transparent, #d9d9d9, transparent);
}

@keyframes loading {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
